import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useHistory } from 'react-router-dom';
import { useOrderContext } from '../../../../components/OrderProvider';
import { useSnackbar } from 'notistack';
import CalculationsSection from '../../../../components/CalculationsSection';
import { orders as ordersApi } from '@afosto/order/api/Orders';
import translations from './translations';

const OrderCalculationsSection = () => {
  const history = useHistory();
  const intl = useIntl();
  const { calculations, fetchOrder, itemCount, order } = useOrderContext();
  const { enqueueSnackbar } = useSnackbar();

  const handleCreateCalculation = async () => {
    try {
      await ordersApi.createCalculation(order?.id, {
        expires_at: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        reference: order?.id,
      });

      await fetchOrder(order?.id);

      enqueueSnackbar(intl.formatMessage(translations.feedback.calculationCreated), {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.calculationNotCreated), {
        variant: 'error',
      });
    }
  };

  const handleCreateCalculationManually = () => {
    history.push(`/orders/${order?.id}/calculation`);
  };

  const showActions = !order?.state?.is_finished;
  const showCreate = !order?.state?.is_finished && itemCount > 0;
  const showCreateAutomatically = order?.type !== 'return' && order?.type !== 'cancellation';
  const showCreateManually = itemCount <= 250;

  return (
    <CalculationsSection
      calculations={calculations}
      onCreate={handleCreateCalculation}
      onCreateManually={handleCreateCalculationManually}
      showActions={showActions}
      showCreate={showCreate}
      showCreateAutomatically={showCreateAutomatically}
      showCreateManually={showCreateManually}
      showOrderCalculationColumns
    />
  );
};

export default OrderCalculationsSection;
